import { GetStaticProps } from 'next';
import { PartnersListDetails } from '@/screens/PartnersDestinationPage/index';
import destinations from 'scripts/cache/destinations.json';
import { getPartner } from '@/common/service/api/Partners/Partners';
import { PartnersListDetailProps } from '@/screens/PartnersDestinationPage/PartnersDestinationPage';
import URL from '@/common/app/utils/urlsUtils';
import { getRedirectsPath } from '@/common/service/api/Redirects/getRedirectsPath';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

type PageStaticProps = {
    state: string;
    destination: string;
};

export const getStaticProps: GetStaticProps<PartnersListDetailProps, PageStaticProps> = async ({
    params,
}) => {
    try {
        if (!params) {
            throw new Error(`PAGE PARTNERS BY DESTINATION: BAD PARAMS: ${params}`);
        }

        const currentPath = `/partners/${params.state}/${params.destination}/`;

        const destinationSlug = params.destination.toLowerCase();
        const pageDestination = destinations.find(
            (destination) => destination.slug.toLowerCase() === destinationSlug
        );

        if (!pageDestination) {
            const redirectPath = await getRedirectsPath(currentPath);

            if (redirectPath === '/404/') {
                return {
                    notFound: true,
                };
            }

            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect: {
                    destination: redirectPath.toLowerCase(),
                    statusCode: 301,
                },
            };
        }

        const rightPath =
            `/partners/${pageDestination.state.code}/${pageDestination.slug}/`.toLowerCase();

        if (currentPath !== rightPath) {
            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect: {
                    destination: rightPath,
                    statusCode: 301,
                },
            };
        }

        const { meta, items } = await getPartner({ destination_id: pageDestination.id });

        if (!meta || !items.length) {
            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect: {
                    destination: `/404/`,
                    statusCode: 301,
                },
            };
        }

        items.forEach((partnerItem) => {
            partnerItem.url =
                `/partners/${pageDestination.state.code}/${pageDestination.slug}/${partnerItem.slug}/${partnerItem.id}/`.toLowerCase();
        });

        const images = [
            `${URL.image}/destination/${pageDestination.id}/${pageDestination.slug}.jpg`,
            `${URL.image}/destination/${pageDestination.id}/${pageDestination.slug}.webp`,
        ];

        const breadcrumbs = [
            {
                url: '/destination/',
                title: 'Destination',
            },
            {
                url: `/destination/${pageDestination.state.code.toLowerCase()}/`,
                title: pageDestination.state.name,
            },
            {
                url: `/destination/${pageDestination.state.code}/${pageDestination.slug}/`.toLowerCase(),
                title: pageDestination.name,
            },
            {
                title: 'Tour Companies',
                url: rightPath,
                unlink: true,
            },
        ];

        return {
            props: {
                meta: meta,
                items: items,
                images: images,
                breadcrumbs: breadcrumbs,
                currentDestination: pageDestination,
            },
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default PartnersListDetails;
